/* eslint-disable @typescript-eslint/no-explicit-any */
import { IconLayoutDashboard } from '@tabler/icons-react'
import { NavItem, type SidebarNavGroup } from '@/types'
import { useAuth0 } from '@auth0/auth0-react'
import Skeleton from 'react-loading-skeleton'
import { useOrganizationFeatures } from '@/hooks/use-organization-features'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'
import { iconMap } from '@/components/icon-map'
import { NavGroup } from '@/components/layout/nav-group'
import { NavUser } from '@/components/layout/nav-user'
import { TeamSwitcher } from '@/components/layout/team-switcher'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user, isAuthenticated, isLoading } = useAuth0()
  const { data: features, isLoading: featuresLoading } =
    useOrganizationFeatures()

  const navGroups: SidebarNavGroup[] = [
    {
      title: 'Ações',
      items: [
        {
          title: 'Início',
          url: '/',
          icon: IconLayoutDashboard,
        },
        ...(features?.map((feature) => ({
          title: feature.name,
          url: feature.path,
          icon: iconMap[feature.icon as keyof typeof iconMap],
        })) || []),
      ].filter(Boolean) as NavItem[], // Type assertion here
    },
  ]

  if (isLoading) return <div>Loading...</div>
  if (!isAuthenticated) return null

  return (
    <Sidebar collapsible='icon' variant='floating' {...props}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {featuresLoading ? (
          <div className='space-y-4 px-4'>
            {[...Array(3)].map((_, i) => (
              <div key={i} className='flex items-center gap-3'>
                <Skeleton className='h-6 w-6 rounded-full' />
                <div className='flex-1 space-y-1'>
                  <Skeleton className='h-4 w-32' />
                  <Skeleton className='h-3 w-12 rounded-full' />
                </div>
              </div>
            ))}
          </div>
        ) : (
          navGroups.map((group) => (
            <NavGroup
              key={group.title}
              title={group.title}
              items={group.items.filter((item) => Boolean(item.icon))}
            />
          ))
        )}
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name: user?.name || 'Guest',
            email: user?.email || 'guest@example.com',
            avatar: user?.picture || '/default-avatar.png',
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
